<template>
  <div class="wrapper">
    <div class="logo">
      <a v-if="url" :href="url" target="_blank">
        <img :src="banner.atturl" alt="log">
      </a>
      <img v-else :src="banner.atturl" alt="log" @click="showTips('敬请期待！')">

      <router-link v-else :to=" url ? url : ''" target="_blank">
        <img :src="banner.atturl" alt="log">
      </router-link>
    </div>
    <div class="goods">
      <div>

        <a :href="good1.url" target="_blank">
          <img :src="good1.atturl" alt="商品">
        </a>
      </div>
      <div>

        <a :href="good2.url" target="_blank">
          <img :src="good2.atturl" alt="商品">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "block",
    props: [
      'data',
      'url',
      'absolute',
    ],
    data() {
      return {
        banner: {
          atturl: ''
        },
        good1: {
          atturl: '',
          url: '',
        },
        good2: {
          atturl: '',
          url: '',
        },
      }
    },
    mounted() {
      const {
        advList: [
          banner,
          good1,
          good2,
        ]
      } = this.data;
      this.banner = banner || {};
      this.good1 = good1 || {};
      this.good2 = good2 || {};
    },
    methods: {
      showTips(string) {
        this.$Message.warning(string);
      }
    }
  }
</script>

<style scoped lang="less">
  .wrapper {
    width: 50%;
    margin: 5px 0;
    display: flex;
    flex-direction: row;
  }

  .logo {
    /*width: 245px;*/
  }

  .goods {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// block.vue?bca7441c